module.exports = __webpack_public_path__ + "static/media/DSCF0665-01.0580339d.jpg";